// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as SmoothscrollPolyfill from "smoothscroll-polyfill";
import MergedRef from "@react-hook/merged-ref";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ResizeObserver2$Showside from "../utils/ResizeObserver2.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as ReactUseDraggableScroll from "react-use-draggable-scroll";
import * as IntersectionObserver$Showside from "../utils/IntersectionObserver.bs.js";
SmoothscrollPolyfill.polyfill();
var getTouchY = function getTouchY(e) {
  return e.touches ? e.touches[0].clientY : 0;
};
var getTouchX = function getTouchY(e) {
  return e.touches ? e.touches[0].clientX : 0;
};
function SimpleSlider(Props) {
  var slides = Props.slides;
  var slidesOffsetBefore = Props.slidesOffsetBefore;
  var slidesOffsetAfter = Props.slidesOffsetAfter;
  var slidesPerViewOpt = Props.slidesPerView;
  var shouldCenterOpt = Props.shouldCenter;
  var shouldShowScrollbarOpt = Props.shouldShowScrollbar;
  var shouldShowArrowsOpt = Props.shouldShowArrows;
  var verticallyCenterOpt = Props.verticallyCenter;
  var lockVerticalScrollWhenSwipingOpt = Props.lockVerticalScrollWhenSwiping;
  var classNameOpt = Props.className;
  var ulClassNameOpt = Props.ulClassName;
  var dataTestId = Props.dataTestId;
  var insetMargin = Props.insetMargin;
  var transformStyle = Props.transformStyle;
  var ariaLabel = Props.ariaLabel;
  var slideIndexOffsetOpt = Props.slideIndexOffset;
  var tabIndex = Props.tabIndex;
  var fwdRef = Props.fwdRef;
  var slideToIndexRef = Props.slideToIndexRef;
  var onMouseLeave = Props.onMouseLeave;
  var onMouseEnter = Props.onMouseEnter;
  var slidesPerView = slidesPerViewOpt !== undefined ? slidesPerViewOpt : "auto";
  var shouldCenter = shouldCenterOpt !== undefined ? shouldCenterOpt : false;
  var shouldShowScrollbar = shouldShowScrollbarOpt !== undefined ? shouldShowScrollbarOpt : false;
  var shouldShowArrows = shouldShowArrowsOpt !== undefined ? shouldShowArrowsOpt : true;
  var verticallyCenter = verticallyCenterOpt !== undefined ? verticallyCenterOpt : false;
  var lockVerticalScrollWhenSwiping = lockVerticalScrollWhenSwipingOpt !== undefined ? lockVerticalScrollWhenSwipingOpt : false;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var ulClassName = ulClassNameOpt !== undefined ? ulClassNameOpt : "";
  var slideIndexOffset = slideIndexOffsetOpt !== undefined ? slideIndexOffsetOpt : 0;
  var scrollRef = React.useRef(null);
  var appliedRef = fwdRef !== undefined ? MergedRef(scrollRef, fwdRef) : scrollRef;
  var scrollContainerRef = React.useRef(null);
  var match = ViewportContext$Showside.use(undefined);
  var windowWidth = match.windowSize.width;
  var containerWidth = Belt_Option.getWithDefault(Belt_Option.map(ResizeObserver2$Showside.useResizeObserver(scrollRef), function (size) {
    return size.width;
  }), 300.0);
  var lastTouchMoveY = React.useRef(0);
  var lastTouchMoveX = React.useRef(0);
  var isScrolling = React.useRef(undefined);
  var firstSlideRef = React.useRef(null);
  var lastSlideRef = React.useRef(null);
  var match$1 = IntersectionObserver$Showside.use(firstSlideRef, scrollRef, true, [1.0], undefined, undefined, undefined, undefined);
  var match$2 = IntersectionObserver$Showside.use(lastSlideRef, scrollRef, true, [0.99], undefined, undefined, undefined, undefined);
  React.useEffect(function () {
    performance.mark && performance.mark('SimpleSlider rendered');
  }, []);
  var match$3 = ReactUseDraggableScroll.useDraggable(scrollRef);
  var extraWrapperCn = shouldCenter && slidesPerView === "auto" ? CSS$Showside.prefix("flex justify-center") : "";
  var extraChildrenCn = shouldCenter ? slidesPerView === "auto" ? CSS$Showside.prefix("w-auto inline-flex") : CSS$Showside.prefix("justify-center") : "";
  var scrollbarCn = shouldShowScrollbar ? "" : CSS$Showside.prefix("no-scrollbar");
  var slides$1 = React.useMemo(function () {
    return Belt_Array.mapWithIndex(slides, function (index, slide) {
      var paddingLeft = index === 0 ? Belt_Option.map(slidesOffsetBefore, CSS$Showside.intToPx) : undefined;
      var paddingRight = index === (slides.length - 1 | 0) ? Belt_Option.map(slidesOffsetAfter, CSS$Showside.intToPx) : undefined;
      var width = slidesPerView === "auto" ? "auto" : "calc(100% / " + slidesPerView + ")";
      var tmp = {
        width: width
      };
      if (paddingRight !== undefined) {
        tmp.paddingRight = paddingRight;
      }
      if (paddingLeft !== undefined) {
        tmp.paddingLeft = paddingLeft;
      }
      var style = tmp;
      var isFirst = index === 0;
      var isLast = index === (slides.length - 1 | 0);
      var ref = isFirst ? Caml_option.some(ReactDOMUtils$Showside.Ref.domRef(firstSlideRef)) : isLast ? Caml_option.some(ReactDOMUtils$Showside.Ref.domRef(lastSlideRef)) : undefined;
      var style$1 = Object.assign({}, style, Belt_Option.mapWithDefault(transformStyle, {}, function (fn) {
        return Curry._1(fn, index);
      }));
      var tmp$1 = {
        key: String(index),
        className: Cn.make([verticallyCenter ? CSS$Showside.prefix("self-center") : "", "swiper-slide"]),
        style: style$1
      };
      if (ref !== undefined) {
        tmp$1.ref = Caml_option.valFromOption(ref);
      }
      return React.createElement("li", tmp$1, slide);
    });
  }, [slides]);
  var onClickNext = function (param) {
    Belt_Option.forEach(Caml_option.nullable_to_opt(scrollRef.current), function (element) {
      var scrollRight = element.scrollWidth - (element.scrollLeft + containerWidth);
      var scrollBy = scrollRight < containerWidth ? scrollRight : containerWidth;
      element.scrollBy({
        behavior: "smooth",
        left: scrollBy,
        top: 0.0
      });
    });
  };
  var onClickPrev = function (param) {
    Belt_Option.forEach(Caml_option.nullable_to_opt(scrollRef.current), function (element) {
      var scrollBy = Caml.float_max(-1.0 * element.scrollLeft, -1.0 * containerWidth);
      element.scrollBy({
        behavior: "smooth",
        left: scrollBy,
        top: 0.0
      });
    });
  };
  var slideToIndex = function (index) {
    Belt_Option.forEach(Belt_Option.flatMap(Caml_option.nullable_to_opt(scrollContainerRef.current), function (element) {
      return Caml_option.nullable_to_opt(element.children.item(index + slideIndexOffset | 0));
    }), function (el) {
      Belt_Option.forEach(Belt_Option.map(el, function (el) {
        return [el.offsetLeft, el.offsetWidth];
      }), function (param) {
        var offsetWidth = param[1];
        var offsetLeft = param[0];
        var left = offsetWidth > windowWidth ? offsetLeft - 12 | 0 : offsetLeft + ((offsetWidth / 2 | 0) - (windowWidth / 2 | 0) | 0) | 0;
        Belt_Option.forEach(Caml_option.nullable_to_opt(scrollRef.current), function (__x) {
          __x.scrollTo({
            behavior: "smooth",
            left: left,
            top: 0.0
          });
        });
      });
    });
  };
  Belt_Option.forEach(slideToIndexRef, function (slideToIndexRef) {
    slideToIndexRef.current = slideToIndex;
  });
  var onTouchStart = function (e) {
    var pageX = getTouchX(e);
    var pageY = getTouchY(e);
    lastTouchMoveX.current = pageX;
    lastTouchMoveY.current = pageY;
  };
  var onTouchMove = function (e) {
    if (!(lockVerticalScrollWhenSwiping && isScrolling.current === undefined)) {
      if (Caml_obj.equal(isScrolling.current, false)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      } else {
        return;
      }
    }
    var pageX = getTouchX(e);
    var pageY = getTouchY(e);
    var diffX = pageX - lastTouchMoveX.current | 0;
    var diffY = pageY - lastTouchMoveY.current | 0;
    var isOnlyScrollingHorizontally = pageY === lastTouchMoveY.current;
    var isSignificantMovement = (Math.imul(diffX, diffX) + Math.imul(diffY, diffY) | 0) >= 25;
    if (isOnlyScrollingHorizontally) {
      isScrolling.current = false;
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!isSignificantMovement) {
      return;
    }
    var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180.0 / Math.PI;
    if (touchAngle > 45.0) {
      isScrolling.current = true;
    } else {
      isScrolling.current = false;
      e.preventDefault();
      e.stopPropagation();
    }
  };
  var onTouchEnd = function (param) {
    isScrolling.current = undefined;
  };
  var tmp = {
    className: Cn.make(["swiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-free-mode", className, extraWrapperCn]),
    style: {
      zIndex: "0"
    }
  };
  if (onMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(onMouseEnter);
  }
  if (onMouseLeave !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(onMouseLeave);
  }
  var tmp$1 = {
    ref: ReactDOMUtils$Showside.Ref.domRef(appliedRef),
    className: Cn.make(["swiper-wrapper", extraChildrenCn, CSS$Showside.prefix(Cn.make(["overflow-x-auto overflow-y-hidden"])), scrollbarCn]),
    role: "navigation",
    onMouseDown: match$3.events.onMouseDown,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart
  };
  if (ariaLabel !== undefined) {
    tmp$1["aria-label"] = Caml_option.valFromOption(ariaLabel);
  }
  if (tabIndex !== undefined) {
    tmp$1.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  var tmp$2 = {
    transform: "translateZ(0)"
  };
  if (insetMargin !== undefined) {
    tmp$2.margin = insetMargin;
  }
  var tmp$3 = {
    children: React.createElement("ul", {
      ref: ReactDOMUtils$Showside.Ref.domRef(scrollContainerRef),
      className: Cn.make(["swiper-wrapper", ulClassName]),
      style: tmp$2
    }, slides$1)
  };
  if (dataTestId !== undefined) {
    tmp$3.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  return React.createElement("div", tmp, React.createElement("div", tmp$1, React.createElement(DataAttribute$Showside.make, tmp$3)), React.createElement(ConditionalRender$Showside.When.make, {
    condition: shouldShowArrows && !match$1.isIntersecting,
    children: React.createElement("div", {
      className: "swiper-button-prev",
      onClick: onClickPrev
    })
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: shouldShowArrows && !match$2.isIntersecting,
    children: React.createElement("div", {
      className: "swiper-button-next",
      onClick: onClickNext
    })
  }));
}
SimpleSlider.displayName = "SimpleSlider";
var make = React.memo(SimpleSlider);
export { getTouchY, getTouchX, make };
/*  Not a pure module */